export default __webpack_public_path__ + "static/media/category-hobbies.e59bb5b3.png";